import { ReactComponent as Logo } from "@king-ict/eupisi-ui/assets/images/logo.svg";
import styles from "@king-ict/eupisi-ui/components/Footer/Footer.module.scss";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { useTranslation } from "react-i18next";

export interface CustomFooterProps {
  downloadUserManual?: () => any;
  downloadTermsOfService?: () => any;
  items?: Array<FooterItem>;
  logoColor?: "normal" | "black";
}

export interface FooterItem {
  label: string;
  callback?: (item: FooterItem) => {};
}

export const CustomFooter = ({
  downloadUserManual,
  downloadTermsOfService,
  items,
  logoColor = "normal",
}: CustomFooterProps) => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <Container>
        <Row className={styles.row}>
          {/* LOGO */}
          <Col xs="12" sm="12" md="3" lg="2" className={styles.logo}>
            {logoColor === "normal" && (
              <Logo aria-label={t("accessibility.footerLogo")} />
            )}
            {/* {logoColor === 'black' && <LogoBlack aria-label={t("accessibility.footerLogo")} />} */}
          </Col>

          {/* ITEMS */}
          {items ? (
            <Col className={styles.links} xs="12" sm="12" md="6" lg="6">
              {items.map((item, ix) => (
                <button
                  key={ix}
                  onClick={() => item.callback && item.callback(item)}
                >
                  {" "}
                  {item.label}{" "}
                </button>
              ))}
            </Col>
          ) : (
            <Col className={styles.links} xs="12" sm="12" md="6" lg="6">
              {downloadTermsOfService === undefined ? null : (
                <button onClick={() => downloadTermsOfService()}>
                  {t("footer.terms")}
                </button>
              )}
              {downloadUserManual === undefined ? null : (
                <button onClick={() => downloadUserManual()}>
                  {t("footer.support")}
                </button>
              )}
            </Col>
          )}

          {/* Copyright  */}
          <Col className={styles.copyright} xs="12" sm="12" md="3" lg="4">
            <span>
              Copyright © Ministarstvo znanosti i obrazovanja {year}. Sva prava
              zadržana
            </span>{" "}
            <br />
            <div style={{ visibility: "hidden" }}>2025-03-06</div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
